import { apiFetch } from './api'

export interface CanvasCardSummary {
  id: string
  title: string
  card_type: 'table' | 'chart' | 'text' | 'metric'
  display_config: Record<string, any>
  row_count: number
  favorited_at: string | null
  created_at: string
  updated_at: string
  is_own: boolean
}

export interface CanvasCardDetail extends CanvasCardSummary {
  query_spec: Record<string, any>
  result_data: {
    columns: string[]
    rows: Record<string, any>[]
    row_count: number
  }
  thread_id: string | null
  message_id: string | null
}

export async function fetchCanvasCards(params?: {
  favorites?: boolean
  limit?: number
  offset?: number
}): Promise<CanvasCardSummary[]> {
  const query = new URLSearchParams()
  if (params?.favorites) query.set('favorites', 'true')
  if (params?.limit) query.set('limit', String(params.limit))
  if (params?.offset) query.set('offset', String(params.offset))
  const qs = query.toString()
  return apiFetch(`/canvas/cards${qs ? '?' + qs : ''}`)
}

export async function fetchCanvasCard(id: string): Promise<CanvasCardDetail> {
  return apiFetch(`/canvas/cards/${id}`)
}

export async function refreshCanvasCard(id: string): Promise<CanvasCardDetail> {
  return apiFetch(`/canvas/cards/${id}/refresh`, { method: 'POST' })
}

export async function updateCanvasCard(
  id: string,
  patch: {
    title?: string
    favorited?: boolean
    display_config?: Record<string, any>
  },
): Promise<CanvasCardDetail> {
  return apiFetch(`/canvas/cards/${id}`, { method: 'PATCH', body: patch })
}

export async function deleteCanvasCard(id: string): Promise<void> {
  await apiFetch(`/canvas/cards/${id}`, { method: 'DELETE' })
}

export async function downloadCanvasCardCsv(cardId: string, title: string): Promise<void> {
  const blob = await apiFetch(`/canvas/cards/${cardId}/download`, { responseType: 'blob' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${title.replace(/[^a-z0-9]/gi, '-').toLowerCase()}.csv`
  a.click()
  URL.revokeObjectURL(url)
}

export async function exportCanvasCards(cardIds: string[]): Promise<Record<string, any>[]> {
  return apiFetch('/canvas/cards/export', {
    method: 'POST',
    body: { card_ids: cardIds },
  })
}

export async function importCanvasCards(cards: Record<string, any>[]): Promise<CanvasCardSummary[]> {
  return apiFetch('/canvas/cards/import', {
    method: 'POST',
    body: { cards },
  })
}
